module.exports = __webpack_public_path__ + "static/BasisGrotesquePro-Regular.0fa14877.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/BasisGrotesquePro-Regular.woff
// module id = 708
// module chunks = 168707334958949